import { Button, Checkbox, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { Form } from "antd";
import { useTagsStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function ManageTagModal({ modalShow, setModalShow }) {
  const [form] = Form.useForm();
  const [isActive, setIsActive] = useState();
  const [order, setOrder] = useState();
  const [dropDownoptions, setDropDownOptions] = useState([]);
  const { orderData, orderLoading, fetchTagData, fetchTagOrder, AddTag } =
    useTagsStore();
  const { setToaster } = useToast();

  useEffect(() => {
    fetchTagOrder();
  }, []);

  useEffect(() => {
    const ordersList = Array.from({ length: 30 }, (_, orderData) => orderData + 1);
    const mappedValues = ordersList?.map((val) => {
      return {
        label: `order ${val}`,
        value: val,
        isDisabled: orderData?.data?.includes(val),
      };
    });
    setDropDownOptions(mappedValues);
  }, [orderData]);

  const handleSubmit = async (data) => {
    const { tagmasterName, tag } = data;

    const tag_data = {
      displayName: tagmasterName,
      order: order,
      isActive: isActive,
      tag: tag,
    };
    AddTag(tag_data, setToaster, fetchTagData, setModalShow);
  };

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Tag
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <Form form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Tag Master Name"
              name="tagmasterName"
              rules={[
                { required: true, message: "Please enter tag master name" },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>

            <Form.Item
              label="Tag"
              name="tag"
              rules={[
                {
                  required: true,
                  message: "Please enter tag",
                },
              ]}
              style={{ width: "78%", marginLeft: "22%" }}
            >
              <Input
                placeholder=""
              />
            </Form.Item>

            <Form.Item
              label="Select order"
              name="order"
              rules={[{ required: true, message: "Select order" }]}
              style={{ width: "91%", marginLeft: "9%" }}
            >
              <Select
                allowClear
                placeholder="Select Order"
                value={order}
                onChange={(role) => {
                  setOrder(role);
                }}
              >
                {dropDownoptions &&
                  dropDownoptions.map((item) => (
                    <Option
                      value={item?.value}
                      key={item.value}
                      disabled={item.isDisabled}
                    >
                      {item.label}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item style={{ width: "80%", marginLeft: "20%" }} label="Status" name="status">
              <Checkbox
                checked={isActive}
                onChange={({ target }) => setIsActive(target.checked)}
              >
                {isActive ? "Active" : "Inactive"}
              </Checkbox>
            </Form.Item>
            <br />
            <Form.Item className="float-end">
              <Button htmlType="submit" type="primary" className="text-center">
                Add Tag
              </Button>
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ManageTagModal;
